/******************************************************************************
 * Copyright (C) 2018 The Trustees of Indiana University
 * SPDX-License-Identifier: BSD-3-Clause
 *****************************************************************************/

export const KEY_CODES = {
	up: 38,
	down: 40,
	left: 37,
	right: 39,
	tab: 9,
	enter: 13,
	escape: 27,
	home: 36,
	end: 35,
	pageUp: 33,
	pageDown: 34,
};
export const PREFIX = "rvt";
export const SUPPRESS_EVENT = true;
